module.exports = __webpack_public_path__ + "static/salon-de-pasajeros---acabado-techo-77c601f751156faae7dd9a31a1fa7f8c.jpg";